import { Routes, Route, Navigate } from 'react-router-dom';
import { PublicLayout } from '@/components/layout/PublicLayout';
import { AppLayout } from '@/components/layout/AppLayout';
import { ProtectedRoute, AdminRoute } from '@/components/ProtectedRoute';

// Public pages
import { Landing } from '@/pages/public/Landing';
import { Features } from '@/pages/public/Features';
import { SampleReport } from '@/pages/public/SampleReport';
import { Pricing } from '@/pages/public/Pricing';
import { Login } from '@/pages/public/Login';
import { Register } from '@/pages/public/Register';
import { Contact } from '@/pages/public/Contact';
import { Privacy } from '@/pages/public/Privacy';
import { Terms } from '@/pages/public/Terms';
import { NotFound } from '@/pages/public/NotFound';

// Anonymous analysis
import { Analyze } from '@/pages/Analyze';
import { AnonResults } from '@/pages/AnonResults';

// App pages
import { AppHome } from '@/pages/app/AppHome';
import { NewAnalysis } from '@/pages/app/NewAnalysis';
import { Results } from '@/pages/app/Results';
import { Projects } from '@/pages/app/Projects';
import { ProjectDetail } from '@/pages/app/ProjectDetail';
import { HistoryPage } from '@/pages/app/HistoryPage';
import { Reports } from '@/pages/app/Reports';
import { SettingsPage } from '@/pages/app/SettingsPage';

// Admin
import { AdminPage } from '@/pages/admin/AdminPage';

export default function App() {
  return (
    <Routes>
      {/* Public marketing + auth */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Landing />} />
        <Route path="/features" element={<Features />} />
        <Route path="/sample-report" element={<SampleReport />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
      </Route>

      {/* Anonymous analysis flow (no layout chrome beyond minimal) */}
      <Route path="/analyze" element={<Analyze />} />
      <Route path="/results/:runId" element={<AnonResults />} />

      {/* Authenticated app */}
      <Route
        path="/app"
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<AppHome />} />
        <Route path="new-analysis" element={<NewAnalysis />} />
        <Route path="results/:runId" element={<Results />} />
        <Route path="projects" element={<Projects />} />
        <Route path="projects/:projectId" element={<ProjectDetail />} />
        <Route path="history" element={<HistoryPage />} />
        <Route path="reports" element={<Reports />} />
        <Route path="settings" element={<SettingsPage />} />
      </Route>

      {/* Admin */}
      <Route
        path="/admin/*"
        element={
          <AdminRoute>
            <AppLayout />
          </AdminRoute>
        }
      >
        <Route path="config" element={<AdminPage />} />
        <Route path="users" element={<AdminPage />} />
        <Route path="workspaces" element={<AdminPage />} />
        <Route path="runs" element={<AdminPage />} />
        <Route path="usage" element={<AdminPage />} />
        <Route path="contact" element={<AdminPage />} />
        <Route index element={<Navigate to="/admin/config" replace />} />
      </Route>

      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
